<template>
  <div v-if="isReady">
    <div class="filter-sidebar">
      <div class="form-group">
        <input type="checkbox" v-model="isShowOnlyPremium" id="only-show-premium-video">
        <label for="only-show-premium-video">
          <i aria-hidden="true" class="fa fa-diamond"></i>
          プレミアム限定動画のみ表示する
        </label>
      </div>
      <div class="form-group">
        <select v-model="sort" class="form-control">
          <option value="">公開日順</option>
          <option value="likes">いいね数順</option>
          <option value="comments">コメント数順</option>
        </select>
      </div>
    </div>
    <div class="video-grid" id="videoGrid">
      <a v-for="video in videos"
        class="video-link"
        :key="video.id"
        :title="video.title"
        @click.stop="handleClickViewVideo(video)"
        >
        <div v-if="video.isTargetPremium" class="premium-badge">
          <i aria-hidden="true" class="fa fa-diamond"></i>
          プレミアム
        </div>
        <div class="video-card">
          <img :src="video.thumbnail" :alt="video.title" class="thumbnail" loading="lazy">
          <div class="video-info">
            <div class="channel-avatar" :style="{ backgroundImage: `url(${categories[`${video.category}`].iconUrl})` }"></div>
            <div>
              <div class="video-title" :title="video.title">{{ video.title }}</div>
              <div class="text-gray">
                <div class="category-name">{{ categories[`${video.category}`].name }}</div>
                <div class="flexbox gap-10">
                  <span> {{ video.createDate }}</span>
                  <span>
                    <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                    {{ video.likes }}
                  </span>
                  <span>
                    <i class="fa fa-comments-o" aria-hidden="true"></i>
                    {{ video.comments }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>
<script>
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      loader: null,
      isReady: false
    }
  },
  computed: {
    isBasicPlan () {
      return this.$store.getters.getUser.memberPlan === '0'
    },
    videos () {
      return this.$store.getters.getDispVideos
    },
    categories () {
      const obj = this.$store.getters.getCategories.reduce((acc, { id, name, iconUrl }) => {
        acc[id] = { name, iconUrl }
        return acc
      }, {})
      return obj
    },
    isShowOnlyPremium: {
      get () {
        return this.$route.query.only_premium === 'true'
      },
      set (val) {
        const query = { ...this.$route.query }

        if (val) {
          query.only_premium = 'true'
        } else {
          delete query.only_premium
        }

        this.$router.replace({ query })
      }
    },
    sort: {
      get () {
        return this.$store.getters.getSort
      },
      set (val) {
        this.sortVideos(val)
      }
    }
  },
  mounted () {
    const logParams = {
      name: eventCode.video.list,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  },
  methods: {
    handleClickViewVideo (video) {
      if (video.isTargetPremium && this.isBasicPlan) {
        this.$emit('openUpgradePlanModal')
        return false
      }
      this.$router.push({
        name: 'VideoPlayer',
        params: {
          id: video.id
        }
      })
    },
    async filterVideos () {
      this.loader = this.$loading.show()
      await this.sleep()
      await this.$store.dispatch('filterVideos', {
        searchQuery: this.$route.query.search_query || '',
        category: this.$route.query.category || '',
        onlyPremium: this.$route.query.only_premium || ''
      })
      this.isReady = true
      this.loader && this.loader.hide()
    },
    async sortVideos (val) {
      this.loader = this.$loading.show()
      await this.sleep()
      this.$store.commit('setSortVideos', val)
      await this.$store.dispatch('sortVideos')
      this.loader && this.loader.hide()
    },
    async sleep (time = 500) {
      await new Promise(resolve => setTimeout(resolve, time))
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler () {
        this.filterVideos()
      }
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>
<style scoped>
.hpanel {
  background-color: #fff;
  padding: 20px;
}
.filter-sidebar {
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  .form-group {
    margin: unset;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #666;
    gap: 10px;
    input[type="checkbox"] {
      margin-top: unset;
    }
    label {
      font-weight: unset;
      margin: unset;
      cursor: pointer;
    }
    .form-control {
      color: #666;
      border: 1px solid #ccc !important;
    }
  }
}
.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  align-items: stretch;
  .video-link {
    text-decoration: none;
    color: inherit;
    display: block;
    height: 100%;
    position: relative;
  }
  .video-card {
    background: #f9f9f9;
    border-radius: 8px;
    overflow: hidden;
    transition: box-shadow 0.2s;
    border: 1px solid #ddd;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .video-card:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
  .thumbnail {
    width: 100%;
    display: block;
    aspect-ratio: 16 / 9;
    object-fit: cover;
    padding: unset;
    margin: unset;
    line-height: unset;
    background-color: unset;
    border: unset;
    border-radius: unset;
  }

  .video-info {
    padding: 10px;
    display: flex;
    gap: 10px;
  }

  .video-title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .category-name {
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/video/VideoList.vue